import React from 'react';
import ActivityClassifications from '../containers/ActivityClassifications.jsx';

export default (props) => (
  <ActivityClassifications {...props} />
);
